/** Default article thumbnail when no image is available (responsive). */
export const ARTICLE_THUMBNAIL_PLACEHOLDER_SRC = "/thumbnail/640X379.png";

export const ARTICLE_THUMBNAIL_PLACEHOLDER_SRCSET =
  "/thumbnail/360X213.png 360w, /thumbnail/640X379.png 640w, /thumbnail/900X533.png 900w, /thumbnail/1280X758.png 1280w, /thumbnail/1920X1138.png 1920w";

const LEGACY_PLACEHOLDER_PATHS = new Set([
  "/thumbnail/placeholder-grey.svg",
  "/images/placeholder-grey-ld.png",
  "/images/placeholder-grey-sd.png",
  "/images/placeholder-grey-md.png",
]);

export function resolveArticlePlaceholder(phImg?: string): {
  src: string;
  srcSet?: string;
} {
  if (phImg === undefined || phImg === "" || LEGACY_PLACEHOLDER_PATHS.has(phImg)) {
    return { src: ARTICLE_THUMBNAIL_PLACEHOLDER_SRC, srcSet: ARTICLE_THUMBNAIL_PLACEHOLDER_SRCSET };
  }
  return { src: phImg };
}
